import { render, staticRenderFns } from "./CompanyProfileSettings.vue?vue&type=template&id=5255b911&scoped=true&"
import script from "./CompanyProfileSettings.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfileSettings.vue?vue&type=style&index=0&id=5255b911&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255b911",
  null
  
)

export default component.exports